import $ from 'jquery'

import initShowPassword from '@/javascript/components/show_password'

$(document).ready(function () {
	initShowPassword()
})
